import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 *
 * This component shows on initial load while Amplify
 * is looking up the visitor's user state.
 *
 */

const AppLoading: React.FC = () => (
  <Box sx={{ alignItems: 'center', display: 'flex', height: '100vh', justifyContent: 'center', width: '100vw' }}>
    <CircularProgress />
  </Box>
);

export default AppLoading;
